import {
    Button,
    Center,
    HStack,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Spinner,
    Text,
    VStack,
} from '@chakra-ui/react';
import { ReportingViewBaseConfig } from '../../../base';
import { SnippetOverlayViewProps } from './snippetOverlayProps';
import { SnippetDetailContainerProps, SnippetDetailViewProps } from '../detail';
import { Suspense } from 'react';

export function createSnippetOverlayView(
    config: ReportingViewBaseConfig & {
        Container: {
            Snippet: {
                Detail: React.FC<SnippetDetailContainerProps>;
            };
        };
    }
): React.FC<SnippetOverlayViewProps> {
    const {
        Container: {
            Snippet: { Detail: DetailContainer },
        },
    } = config;

    const Detail: React.FC<SnippetDetailViewProps> = (props) => {
        return (
            <VStack w="full" align="start" spacing={{ base: 3, xl: 5 }}>
                <HStack fontSize="md" justify="space-between" w="full">
                    <Text fontWeight="semibold" color="whiteAlpha.800" userSelect="none">
                        Snippet
                    </Text>
                    <Text
                        fontWeight="bold"
                        color="whiteAlpha.400"
                        textTransform="uppercase"
                        fontSize="xs"
                        userSelect="none"
                    >
                        Plain text
                    </Text>
                </HStack>
                <HStack
                    p={3}
                    w="full"
                    borderWidth={1}
                    borderColor="whiteAlpha.200"
                    borderRadius="md"
                    minH="10rem"
                    maxH="20rem"
                    overflowY="auto"
                    fontSize="sm"
                    color="whiteAlpha.700"
                    bg="blackAlpha.100"
                    align="start"
                >
                    <pre>{props.textarea.value}</pre>
                </HStack>
                <HStack justifyContent="end" w="full" spacing={2}>
                    {props.cancel && (
                        <Button
                            {...props.cancel.button}
                            size="sm"
                            bg="none"
                            color="whiteAlpha.600"
                            _hover={{ bg: 'whiteAlpha.50' }}
                            _active={{ bg: 'whiteAlpha.100' }}
                            _focus={{ outline: 'none' }}
                            _focusVisible={{ outline: 'none' }}
                        >
                            Close
                        </Button>
                    )}
                    {/* <Button
                        {...props.submit.button}
                        size="sm"
                        bg="whiteAlpha.900"
                        color="blackAlpha.900"
                        _hover={{ bg: 'whiteAlpha.800' }}
                        _active={{ bg: 'whiteAlpha.900' }}
                        _focus={{ outline: 'none' }}
                        _focusVisible={{ outline: 'none' }}
                    >
                        Update
                    </Button> */}
                </HStack>
            </VStack>
        );
    };

    return ({ ...props }) => {
        return (
            <Modal {...props.modal} size={{ base: 'full', lg: 'lg', xl: 'xl' }}>
                <ModalOverlay />
                <ModalContent
                    bg="black"
                    _focus={{ outline: 'none' }}
                    _focusVisible={{ outline: 'none' }}
                    position="relative"
                    overflow="hidden"
                >
                    <ModalBody bg="whiteAlpha.100" p={{ base: 3, xl: 5 }}>
                        <Suspense
                            fallback={
                                <Center w="full" color="whiteAlpha.400">
                                    <Spinner />
                                </Center>
                            }
                        >
                            {props.detail && (
                                <DetailContainer as={Detail} {...props.detail} />
                            )}
                        </Suspense>
                    </ModalBody>
                </ModalContent>
            </Modal>
        );
    };
}
